import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { API_ALL_FACTORS_URL } from "constants/apiUrls";

import { FactorData } from "types/factor/factor";

import { QueryKey } from "types/queryKey/queryKey";

import useGetApiClient from "./useGetApiClient";

function useGetAllFactors(): UseQueryResult<FactorData> {
  const apiClient = useGetApiClient();

  return useQuery({
    queryKey: [QueryKey.AllFactors],
    queryFn: () => {
      return apiClient(API_ALL_FACTORS_URL).then((res) => res.json());
    },
  });
}

export default useGetAllFactors;
